var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "box_icon",
    "data-name": "box icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.299,
    height: 59.297,
    viewBox: "0 0 59.299 59.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b19f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2253f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176915",
    "data-name": "Group 176915",
    transform: "translate(0 6.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176914",
    "data-name": "Group 176914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62008",
    "data-name": "Path 62008",
    d: "M14.869,25.278c-6.627,0-12.021-5.09-12.021-11.348S8.242,2.581,14.869,2.581,26.89,7.671,26.89,13.93,21.5,25.278,14.869,25.278Zm0-21.176c-5.794,0-10.5,4.4-10.5,9.828s4.706,9.828,10.5,9.828,10.5-4.4,10.5-9.828S20.663,4.1,14.869,4.1Z",
    transform: "translate(20.287 10.959)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62009",
    "data-name": "Path 62009",
    d: "M18.554,18.274a.7.7,0,0,1-.432-.144L4.8,8.847A.759.759,0,0,1,5.669,7.6l12.693,8.835,1.713-2.449L7.59,5.261a.759.759,0,1,1,.864-1.248l13.109,9.156a.767.767,0,0,1,.192,1.056l-2.577,3.7a.822.822,0,0,1-.5.32.193.193,0,0,1-.128.032Z",
    transform: "translate(37.41 24.574)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62010",
    "data-name": "Path 62010",
    d: "M4.116,11.563a.768.768,0,0,1-.768-.768V4.072A.768.768,0,0,1,4.116,3.3a.758.758,0,0,1,.768.768v6.723A.768.768,0,0,1,4.116,11.563Z",
    transform: "translate(25.549 18.56)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62011",
    "data-name": "Path 62011",
    d: "M5.132,11.582a.768.768,0,0,1-.768-.768V4.091a.768.768,0,0,1,.768-.768.758.758,0,0,1,.768.768v6.723A.768.768,0,0,1,5.132,11.582Z",
    transform: "translate(36.235 18.765)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62012",
    "data-name": "Path 62012",
    d: "M4.387,10.011a.768.768,0,0,1-.768-.768V4.233a.768.768,0,0,1,.768-.768.758.758,0,0,1,.768.768v5.01A.779.779,0,0,1,4.387,10.011Z",
    transform: "translate(28.4 20.256)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62013",
    "data-name": "Path 62013",
    d: "M4.893,10.022a.768.768,0,0,1-.768-.768V4.259a.768.768,0,0,1,.768-.768.758.758,0,0,1,.768.768V9.253A.779.779,0,0,1,4.893,10.022Z",
    transform: "translate(33.72 20.534)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62014",
    "data-name": "Path 62014",
    d: "M4.655,15.641a.768.768,0,0,1-.768-.768V3.716a.768.768,0,0,1,.768-.768.758.758,0,0,1,.768.768V14.873a.779.779,0,0,1-.768.768Z",
    transform: "translate(31.221 14.818)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62015",
    "data-name": "Path 62015",
    d: "M8.594,18.362a.745.745,0,0,1-.5-.192L1.1,12.024a.724.724,0,0,1-.256-.656.776.776,0,0,1,.384-.576L18.005,1.555a.754.754,0,0,1,.9.128l6.306,6.194a.73.73,0,0,1,.224.64.748.748,0,0,1-.384.56L8.978,18.266a.852.852,0,0,1-.384.1ZM2.911,11.591,8.69,16.665,23.416,8.246,18.23,3.156,2.911,11.591Z",
    transform: "translate(-0.841 -0.82)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62016",
    "data-name": "Path 62016",
    d: "M20.951,18.1a.743.743,0,0,1-.464-.16.765.765,0,0,1-.144-1.072l4.626-6.146L11.363,3.1,4.913,8.832l11.332,6.226a.766.766,0,0,1-.736,1.345L3.232,9.649a.7.7,0,0,1-.384-.576A.74.74,0,0,1,3.1,8.416L10.771,1.6a.774.774,0,0,1,.88-.1L26.489,9.809a.761.761,0,0,1,.368.512.707.707,0,0,1-.144.608L21.559,17.78a.731.731,0,0,1-.608.32Z",
    transform: "translate(20.223 -1.406)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62017",
    "data-name": "Path 62017",
    d: "M17.6,20.931a.76.76,0,0,1-.4-.112L1.2,11.087a.723.723,0,0,1-.352-.56A.762.762,0,0,1,1.067,9.9L8.062,3.02a.754.754,0,0,1,.9-.128l16.134,8.723a.72.72,0,0,1,.384.544.79.79,0,0,1-.192.64l-7.123,7.907a.878.878,0,0,1-.56.224ZM2.828,10.286l14.646,8.9,6.05-6.723-14.79-8L2.828,10.286Z",
    transform: "translate(-0.837 13.242)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62018",
    "data-name": "Path 62018",
    d: "M18.683,25.066a.744.744,0,0,1-.368-.1l-16.5-9.06a.762.762,0,0,1-.4-.672V6.5A.768.768,0,0,1,2.18,5.73a.758.758,0,0,1,.768.768V14.79L17.93,23.017l.032-18.711a.76.76,0,1,1,1.521.016l-.032,19.992a.78.78,0,0,1-.368.656,1.128,1.128,0,0,1-.4.1Z",
    transform: "translate(5.173 21.191)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62019",
    "data-name": "Path 62019",
    d: "M3.6,17.041a.741.741,0,0,1-.656-.384.762.762,0,0,1,.288-1.04L19.287,6.493V5.084a.768.768,0,0,1,.768-.768.758.758,0,0,1,.768.768V6.925a.741.741,0,0,1-.384.656L4,16.913a.691.691,0,0,1-.4.128Z",
    transform: "translate(20.254 29.216)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173587",
    "data-name": "Rectangle 173587",
    width: 59.297,
    height: 59.297,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowOrder);
export default __webpack_public_path__ + "static/media/follow-order.2d966f85cf3cf2f409927d63b62ba64a.svg";
export { ForwardRef as ReactComponent };